import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import Button from './Button';
// @ts-ignore - the Button throws TS error due to refs that may be checked at a later point in time
const ToggleButton = (props) => _jsx(Button, Object.assign({}, props, { asToggle: true }));
export default ToggleButton;
